module.exports = __webpack_public_path__ + "img/中国网球协会@2x.783b49e4.png";